module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 14a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zM8 14a2 2 0 110 4 2 2 0 010-4z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/basic/asda-more-actions.svg
// module id = 631
// module chunks = 0